// extracted by mini-css-extract-plugin
export var hiwSection = "howItWorkSection-module--hiwSection--GbZGc";
export var title = "howItWorkSection-module--title--Q+Yqv";
export var description = "howItWorkSection-module--description--nOyU6";
export var howItWorkTabContent = "howItWorkSection-module--howItWorkTabContent--YWqh0";
export var learnMoreBut = "howItWorkSection-module--learnMoreBut--zgAys";